<template>
  <v-row>
    <v-col cols="12">
      <v-card class="px-0">
        <v-skeleton-loader v-if="$store.state.subscriptions.retrieveLoader" transition="fade-transition" type="toolbar"/>
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Cupones</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-query-builder :query-map="rules" model="coupon" class="mr-1" />
              <v-btn @click="dialogCoupon=true" outlined color="secondary"><v-icon left small>mdi-plus</v-icon> Nuevo</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <v-skeleton-loader v-if="$store.state.subscriptions.retrieveLoader" transition="fade-transition" type="table"/>
          <template v-else>
            <v-col v-if="!couponsList.length" class="text-center py-5">
              <v-icon class="d-block" color="secondary" size="70">mdi-cube</v-icon>
              <span class="d-block subtitle-1">Aún no tienes cupones de descuento</span>
              <v-btn class="my-5" @click="dialogCoupon=true" outlined>Crear un cupón</v-btn>
            </v-col>
            <template v-else>
              <v-data-table :headers="headers" :items="couponsList" :items-per-page="pagination" mobile-breakpoint hide-default-footer hide-default-header disable-sort
              @click:row="(couponsList) => { $router.push({ name: 'CouponRetrieveUpdate', params: { id: couponsList.id }}) }" style="cursor: pointer">
               <!-- header -->
                <template v-slot:header="{ props: { headers } }">
                  <VTableHeaders :headers="headers" @sort="setSort" />
                </template>
                <!-- end header -->
                <template v-slot:[`item.name`]="{ item }">
                  <span class="text--secondary font-weight-medium">{{item.name}}</span>
                </template>
                <template v-slot:[`item.apply_on`]="{ item }">
                  <span>{{item.apply_on === 'invoice' ? 'Suscripción' : 'Línea de suscripción'}}</span>
                </template>
                <template v-slot:[`item.duration_times`]="{ item }">
                  <span>{{item.apply_scheme === 'recurring' ? item.duration_times : 1}}</span>
                </template>
                <template v-slot:[`item.amount`]="{ item }">
                  <span class="text--secondary font-weight-medium" v-if="item.discount_scheme === '%'">{{item.amount | number(false)}}%</span>
                  <span class="text--secondary font-weight-medium" v-if="item.discount_scheme === '$'">{{item.amount | number(item.currency.rounded)}} {{item.currency.id}}</span>
                  <div>
                    <span v-if="item.duration_scheme === 'one_time'">por un ciclo de facturación</span>
                    <span v-if="item.duration_scheme === 'forever'">por siempre</span>
                    <span v-if="item.duration_scheme === 'limited'">por {{item.duration_times}} ciclos de facturación</span>
                  </div>
                </template>
                <template v-slot:[`item.valid_until`]="{ item }">
                  <span v-if="item.valid_until">{{item.valid_until | date}}</span>
                  <span class="font-italic text--disabled" v-else>Sin fecha de caducidad</span>
                </template>
                <template v-slot:[`item.created`]="{ item }">
                  <span>{{item.created | dateTime}}</span>
                </template>
              </v-data-table>
              <template v-if="showPagination || showAll">
                <v-divider />
                <v-row class="mx-0" align="center">
                  <template v-if="showPagination">
                    <v-col cols="6">
                      <span class="body-2 text--secondary">{{count}} registros</span>
                    </v-col>
                    <v-col cols="6" class="text-right">
                      <v-pagination v-model="page" :length="totalPages" total-visible="6" />
                    </v-col>
                  </template>
                </v-row>
              </template>
            </template>
          </template>
        </v-card-text>
      </v-card>

      <!-- dialog new cupon -->
      <v-dialog v-model="dialogCoupon" width="600" persistent no-click-animation scrollable>
        <v-card>
          <v-card-title class="pa-0">
            <v-toolbar flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Crear un cupón</v-toolbar-title>
              <v-spacer />
              <v-toolbar-items>
                <v-row align="center" justify="center" class="mr-1">
                  <v-btn class="ml-3" @click="dialogCoupon=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
                </v-row>
              </v-toolbar-items>
            </v-toolbar>
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-0 background-card">
            <v-list class="v-list-form py-6 transparent">
              <v-list-item>
                <v-list-item-title>Nombre</v-list-item-title>
                <v-list-item-subtitle class=" text-left py-1">
                  <v-text-field v-model.trim="$v.newCoupon.name.$model" :error="$v.newCoupon.name.$error" background-color="white" outlined required single-line dense maxlength="56" placeholder="Escribe un nombre" hide-details/>
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="mt-4">
                <v-list-item-title>
                  <span class="text--secondary font-weight-medium">Descuento</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item class="mt-2">
                <v-list-item-title>Moneda</v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-select v-model="$v.newCoupon.currency.$model" :error="$v.newCoupon.currency.$error" :items="currencies" item-value="id" item-text="name" label="Elige una moneda" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="30" outlined single-line dense hide-details>
                    <template v-slot:item="data">
                      <v-list-item-title>{{data.item.id}} - {{data.item.name}}</v-list-item-title>
                    </template>
                  </v-select>
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>Valor</v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-row no-gutters>
                    <v-col cols="5">
                      <v-text-field v-model.number="$v.newCoupon.amount.$model" :error="$v.newCoupon.amount.$error" oninput="this.value=this.value.replace(/[^0-9.]/g,'');" background-color="white" outlined required single-line dense hide-details />
                    </v-col>
                    <v-spacer />
                    <v-col cols="6">
                      <v-select v-model="$v.newCoupon.discount_scheme.$model" :error="$v.newCoupon.discount_scheme.$error" :items="item" item-value="value" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="30" outlined single-line dense hide-details />
                    </v-col>
                  </v-row>
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>Aplicable a</v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-select v-model="$v.newCoupon.apply_on.$model" :error="$v.newCoupon.apply_on.$error" :items="itemRedemptions" item-value="value" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="30" outlined single-line dense hide-details />
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="mt-4">
                <v-list-item-title>
                  <span class="text--secondary font-weight-medium">Duración</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item class="mt-2">
                <v-list-item-title>Tipo</v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-col cols="6">
                    <v-select v-model="$v.newCoupon.duration_scheme.$model" :error="$v.newCoupon.duration_scheme.$error" :items="itemDuration" item-value="value" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="30" outlined single-line dense hide-details />
                  </v-col>
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item v-if="newCoupon.duration_scheme === 'limited'">
                <v-list-item-title>Ciclos</v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-col cols="8">
                    <v-text-field v-model.number="$v.newCoupon.duration_times.$model" :error="$v.newCoupon.duration_times.$error" suffix="ciclos de facturación" background-color="white" outlined required single-line dense hide-details/>
                  </v-col>
                </v-list-item-subtitle>
              </v-list-item>
              <v-list-item class="mt-4">
                <v-list-item-title>
                  <span class="text--secondary font-weight-medium">Validez</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item class="mt-2">
                <v-list-item-title>
                  Hasta
                  <v-tooltip right max-width="280px" transition="scale-transition">
                    <template v-slot:activator="{on}">
                      <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                    </template>
                    <span>Una fecha límite para que este cupón pueda ser aplicado a nuevas suscripciones.</span>
                  </v-tooltip>
                </v-list-item-title>
                <v-list-item-subtitle class="py-1">
                  <v-col cols="6">
                    <v-menu ref="menu" v-model="menu" :return-value.sync="today" :close-on-content-click="false" offset-y :nudge-bottom="10" transition="slide-y-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="newCoupon.valid_until" v-bind="attrs" v-on="on" background-color="white" outlined single-line no-title="true" dense readonly hide-details>
                          <template v-slot:append>
                            <v-icon small class="mx-3" color="secondary">mdi-calendar</v-icon>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="newCoupon.valid_until" :min="today" type="date" @input="menu=false" locale="es-cl" width="280" color="primary" no-title :first-day-of-week="1">
                        <v-row class="py-2 px-6" align="center" justify="space-between">
                          <v-btn @click="() => { newCoupon.valid_until=null; menu=false }" outlined>Limpiar</v-btn>
                          <v-btn @click="() => { newCoupon.valid_until=today; menu=false }" color="primary">Hoy</v-btn>
                        </v-row>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-list-item-subtitle>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-divider />
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn @click="dialogCoupon=false" outlined color="secondary">Cancelar</v-btn>
            <v-btn @click="createCoupon" :loading="$store.state.subscriptions.createLoader" color="primary">Crear cupón</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- end dialog new cupon -->
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, requiredIf, integer, decimal, minValue, maxValue, maxLength } from 'vuelidate/lib/validators'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import ListViewMixin from '@/mixins/ListViewMixin'
import VTableHeaders from '@/components/VTable/VTableHeaders'
export default {
  components: {
    VQueryBuilder,
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    menu: false,
    newCoupon: {
      name: '',
      currency: null,
      amount: null,
      discount_scheme: '$',
      valid_until: null,
      apply_on: 'invoice',
      duration_scheme: 'one_time',
      duration_times: null
    },
    dialogCoupon: false,
    rules: [
      {
        type: 'text',
        id: 'name',
        label: 'Nombre',
        operators: ['contiene']
      },
      {
        type: 'numeric',
        id: 'amount',
        label: 'Precio',
        operators: ['es igual', 'es menor a', 'es mayor a']
      },
      {
        type: 'select',
        id: 'apply_on',
        label: 'Aplicable a',
        choices: [
          {value: 'invoice', label: 'Suscripción completa'},
          {value: 'line', label: 'Línea de suscripción'}
        ]
      },
      {
        type: 'select',
        id: 'duration_scheme',
        label: 'Tipo de duración',
        choices: [
          {value: 'one_time', label: 'Una vez'},
          {value: 'forever', label: 'Para siempre'},
          {value: 'limited', label: 'Limitado'}
        ]
      }
    ],
    item: [
      { name: '$ Monto fijo', value: '$' },
      { name: '% Procentaje', value: '%' }
    ],
    itemRedemptions: [
      { name: 'Suscripción completa', value: 'invoice' },
      { name: 'Línea de suscripción', value: 'line' }
    ],
    itemDuration: [
      { name: 'Una vez', value: 'one_time' },
      { name: 'Para siempre', value: 'forever' },
      { name: 'Limitado', value: 'limited' }
    ],
      headers: [
      { text: 'Nombre', value: 'name', width: 200, sortable: true },
      { text: 'Aplicable a', value: 'apply_on', align: 'start', class: 'font-weight-bold', sortable: false, width: 150},
      { text: 'Monto', value: 'amount', class: 'font-weight-bold', align: 'start', width: 180, sortable: true },
      { text: 'Válido hasta', value: 'valid_until', align: 'end', width: 180, sortable: true },
      { text: 'Creado el', value: 'created', align: 'end', width: 150, sortable: true }
    ]
  }),
  computed: mapState({
    count: state => state.subscriptions.couponsCount,
    couponsList: state => state.subscriptions.couponsList
  }),
  methods: {
    createCoupon () {
      this.$v.newCoupon.$touch()
      if (this.$v.newCoupon.$invalid) {
        return false
      }
      this.$store.dispatch('subscriptions/CREATE', {
        resource: 'coupons',
        payload: this.newCoupon
      })
      .then((response) => {
        this.dialogCoupon = false
        this.$router.push({
          name: 'CouponRetrieveUpdate',
          params: {
            id: response.data.id
          }
        })
      })
      .catch(() => {
        this.$dialog.message.error('Error al crear el cupón.')
      })
    },
    getList () {
      this.$store.dispatch('subscriptions/LIST', {
        resource: 'coupons',
        query: this.$route.query
      })
    }
  },
  validations: {
    newCoupon: {
      name: {
        required,
        maxLength: maxLength(56)
      },
      currency: {
        required
      },
      amount: {
        required,
        decimal,
        maxPercent: function () {
          if (this.newCoupon.discount_scheme === '%') {
            return this.newCoupon.amount <= 100
          }
          return true
        }
      },
      discount_scheme: {
        required
      },
      apply_on: {
        required
      },
      duration_scheme: {
        required
      },
      duration_times: {
        required: requiredIf(function () {
          return this.newCoupon.duration_scheme === 'limited'
        }),
        integer,
        minValue: minValue(2),
        maxValue: maxValue(120)
      }
    }
  }
}
</script>